import { render } from "./BetsList.vue?vue&type=template&id=37051d5e&scoped=true"
import script from "./BetsList.vue?vue&type=script&lang=js"
export * from "./BetsList.vue?vue&type=script&lang=js"

import "./BetsList.vue?vue&type=style&index=0&id=37051d5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37051d5e"]])

export default __exports__